import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { HttpCacheManager } from '@ngneat/cashew';
import { UserService } from '../services/user.service';
import { SharedService } from '../services/shared.service';

@Injectable({ providedIn: 'root' })
export class TranslationResolver implements Resolve<void> {
    private readonly TIMESTAMP_KEY = 'translation_timestamp';

    constructor(
        private httpClient: HttpClient,
        private userService: UserService,
        private cacheManager: HttpCacheManager,
        private sharedService: SharedService
    ) {}

    async resolve(): Promise<void> {
        try {
            const formData = new FormData();
            formData.append('option', 'current_translation_update_timestamp');
            const data = await lastValueFrom(
                this.httpClient.post<any>(
                    `hippo/ajax_navigator.php?page=pages/api/Ajax_common_lists.php&uid=${this.userService.user.uid}&page_type=json`,
                    formData,
                    { observe: 'response' }
                )
            );

            const newTimestamp = JSON.stringify(data.body.result);
            const storedTimestamp = localStorage.getItem(this.TIMESTAMP_KEY);

            if (newTimestamp && newTimestamp !== storedTimestamp) {
                localStorage.setItem(this.TIMESTAMP_KEY, newTimestamp);
                // Drop every cached translation, not just `translate-page-*`.
                // The app loads many transloco scopes (page, group, codext,
                // p_wpo, p_usd, p_nfd, p_stp, ...), each cached under
                // `translate-<scope>-<lang>-<uid>`. Deleting only the two page
                // keys left every other scope serving stale translations from
                // localStorage until the 24h TTL, so changes appeared only
                // after a re-login (which clears the whole cache). Mirror that
                // proven login-time behaviour here.
                this.cacheManager.clear();
                window.location.reload();
            }
        } catch (error: any) {
            if (
                error?.name === 'AbortError' ||
                error?.status === 0 ||
                error?.statusText === 'Unknown Error'
            ) {
                return;
            }
            const result = error?.error?.result;
            if (
                result !== 'page access denied' &&
                result?.message !== 'page access denied'
            ) {
                this.sharedService.showDataNotLoaded(
                    error,
                    'TranslationResolver',
                    'resolve'
                );
            }
        }
    }
}
